import { render, staticRenderFns } from "./RbuSectionFluctuationTableHeader.vue?vue&type=template&id=3232f0ad"
import script from "./RbuSectionFluctuationTableHeader.vue?vue&type=script&lang=js"
export * from "./RbuSectionFluctuationTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports